<app-header-component
    *ngIf="i18nData && !appLoading"
    (toggleLeftMenuMobile)="pushedRight = !pushedRight; toggleNoScrollMobile()"
    (toggleRightMenuMobile)="pushedLeft = !pushedLeft; toggleNoScrollMobile()"
    (toggleNoscroll)="toggleNoScroll()"
></app-header-component>

<app-loader [loading]="appLoading" [fullPage]="true"></app-loader>
<main *ngIf="!appLoading" id="main" data-ui-view="" class="ng-scope" style="display: block" [ngClass]="{ 'header__menu--push-right': pushedRight, 'push-to-left': pushedLeft }">
    <div id="toast-container" ng-class="[config.position, config.animation]" class="ng-scope toast-top-right">
        <!-- ngRepeat: toaster in toasters -->
    </div>
    <router-outlet *ngIf="i18nData && !appLoading"></router-outlet>
</main>
<app-footer-component *ngIf="i18nData && !appLoading"></app-footer-component>
<app-error-modal-component></app-error-modal-component>
